/**
 * External Imports
 */
import { FC } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

/**
 * Nexus Imports
 */
import { NeuNavVertical } from '@neutron/react';

/**
 * Internal Imports
 */
import { RootState } from '../../../redux/store';
import { useUserRolesRef } from '../../../services/UserRoles/userRoles';

/**
 * Style Imports
 */
import { SideNavLabel } from '../SideNav.styles';
import ValidationSideNavSection from './validationSideNavSection/ValidationSideNavSection';

const AccountSideNav: FC<{}> = () => {
  const { pathname } = useLocation();
  const {
    isEnterpriseAdmin,
    isEmployeeRounder,
    isIlobRounder,
    isCSCRounder,
    isCNEdRounder
  } = useUserRolesRef();

  return (
    <NeuNavVertical
      id="Side-Nav"
      className="h-auto"
      kind="outlined"
      label="MENU"
      menu="blue"
      mode="drawer"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.15) 0 2px 4px',
        '--nav-width-drawer': 'clamp(200px, 25vw, 200px)'
      }}
    >
      <NeuNavVertical
        unit="header"
        style={{
          padding:
            '0 calc(var(--nav-padding-x) / 1.5) calc(var(--nav-padding-y) / 0.75)'
        }}
      />
      <NeuNavVertical unit="content" style={{ overflow: 'clip' }}>
        {(isEnterpriseAdmin || isEmployeeRounder || isIlobRounder) && (
          <>
            <Link to="/account/employee-rounding-settings/employee-list">
              <NeuNavVertical
                id="Side-Nav-My-Employee-List-Label"
                active={
                  pathname === '/account/employee-rounding-settings' ||
                  pathname.includes('employee-list')
                }
                unit="item"
              >
                <SideNavLabel>Direct Reports List</SideNavLabel>
              </NeuNavVertical>
            </Link>
            <Link to="/account/employee-rounding-settings/delegate-list">
              <NeuNavVertical
                id="Side-Nav-My-Delegates-Label"
                data-testid="Side-Nav-My-Delegates-Label"
                active={pathname.includes('delegate-list')}
                unit="item"
              >
                <SideNavLabel> My Delegates </SideNavLabel>
              </NeuNavVertical>
            </Link>
            <Link to="/account/employee-rounding-settings/delegated-to-me">
              <NeuNavVertical
                id="Side-Nav-Lists-Delegated-To-Me-Label"
                active={pathname.includes('delegated-to-me')}
                unit="item"
              >
                <SideNavLabel>Lists Delegated To Me </SideNavLabel>
              </NeuNavVertical>
            </Link>
            <Link to="/account/employee-rounding-settings/adhoc-list">
              <NeuNavVertical
                id="Side-Nav-My-Adhoc-Label"
                data-testid="Side-Nav-My-Adhoc-Label"
                active={pathname.includes('adhoc-list')}
                unit="item"
              >
                <SideNavLabel> Ad Hoc List </SideNavLabel>
              </NeuNavVertical>
            </Link>
          </>
        )}
        <ValidationSideNavSection />
        {isCSCRounder && (
          <Link to="/account/employee-rounding-settings/csc-list">
            <NeuNavVertical
              id="Side-Nav-Lists-CSRN-Label"
              data-testid="Side-Nav-Lists-CSRN-Label"
              active={pathname.includes('csc-list')}
              unit="item"
            >
              <SideNavLabel>CSC List</SideNavLabel>
            </NeuNavVertical>
          </Link>
        )}
        {isCNEdRounder && (
          <Link to="/account/employee-rounding-settings/cned-list">
            <NeuNavVertical
              id="Side-Nav-Lists-CNEd-Label"
              data-testid="Side-Nav-Lists-CNEd-Label"
              active={pathname.includes('cned-list')}
              unit="item"
            >
              <SideNavLabel>CNEd List</SideNavLabel>
            </NeuNavVertical>
          </Link>
        )}
      </NeuNavVertical>
    </NeuNavVertical>
  );
};

const mapReduxStateToProps = (state: RootState) => ({
  authorizedUser: state.AuthorizedUser.authorizedUser
});
export default connect(mapReduxStateToProps)(AccountSideNav);
